import axios from 'axios'

const API = axios.create({
  baseURL: process.env.VUE_APP_UTILITARIOS_API
})
export default {
  getVoucher () {
    return API.get('redemSandboxAppVoucher').then((res) => {
      return res.data
    }).catch((err) => {
      return err.response.data
    })
  }
}
